import { ORDER_TRACKING } from '@constants/index'
import moment = require('moment')
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BsCheckCircleFill } from 'react-icons/bs'
import { IoIosArrowForward } from 'react-icons/io'
import ShippingTrackingHistory from './order-shipping-details'

export const formatDate = (date: string, time: string) => {
  if (date && time) {
    const formattedDate = moment(`${date}T${time}`).format(
      'dddd, MMMM Do, YYYY - h:mm A',
    )
    return formattedDate
  }
  return ''
}
const OrderTrackingInfo = ({
  tracking_info,
  onSelectTracking,
  order_info,
  notStarted,
  inprogress,
  shipping_address,
}: OrderTrackingInfo) => {
  const [selected, setSelected] = useState(0)
  const [showshippingDetails, setShowShippingDetail] = useState(false)
  const { t: translate } = useTranslation('trackorder')
  if (!tracking_info || !Object.keys(tracking_info).length) return null
  let {
    carrier,
    deliverydate,
    carrier_title,
    deliverylocation,
    deliveryto,
    status,
    progressdetail,
    service,
    weight,
    tracking,
    deliverytime,
    message,
  } = Object.values(tracking_info)[selected]?.track_data

  let items = Object.values(tracking_info)[selected].items
  let isUpsFreight = false

  if (progressdetail) {
    let newProgressDetail = progressdetail.find(
      (detail: { activity: string }) => detail.activity === 'Origin Scan',
    )
    isUpsFreight = newProgressDetail ? false : true
  }
  const handleSelection = (index: number) => {
    setSelected(index)
    onSelectTracking(index)
  }
  const handleShipmentDetails = () => {
    setShowShippingDetail(!showshippingDetails)
  }
  return (
    <>
      {showshippingDetails && (
        <ShippingTrackingHistory
          tracking_info={tracking_info}
          selectedIndex={selected}
          showShipping={handleShipmentDetails}
        />
      )}
      {!showshippingDetails && (
        <>
          <div
            className="flex flex-col xl:flex-row gap-5"
            id="headlessui-radiogroup-:rb:"
            role="radiogroup"
          >
            <div className="border-border-base font-sofia   text-brand-dark shadow-trackorderBox relative rounded-md xl:max-w-xs flex-1 group address__box">
              <h3 className="font-normal text-xl  bg-brand-darkblue py-2 rounded-tl-lg rounded-tr-lg text-white text-center ">
                {translate('order', { ns: 'trackorder' })}:
                <span className="font-normal">#{order_info?.increment_id}</span>
              </h3>
              <div className=" px-6 p-1 pb-6">
                <div className="font-normal mb-10  text-[15px]">
                  {translate('ordered-on', { ns: 'trackorder' })}:{' '}
                  {formatDate(
                    order_info?.create_at.split(' ')[0],
                    order_info?.create_at.split(' ')[1],
                  )}
                </div>
                <h3 className="font-normal text-sm  text-[15px]">
                  {translate('status', { ns: 'trackorder' })}:{' '}
                  <span
                    className={`  
            ${
              notStarted
                ? 'text-brand-danger'
                : inprogress
                ? 'text-yellow-100'
                : 'text-brand-green'
            }`}
                  >
                    {notStarted
                      ? ORDER_TRACKING.NOT_SHIPPED
                      : inprogress
                      ? ORDER_TRACKING.IN_PROGRESS
                      : ORDER_TRACKING.DELIVERED}
                  </span>
                </h3>
              </div>
            </div>
            {!message &&
            carrier !== ORDER_TRACKING.YRC &&
            carrier !== ORDER_TRACKING.HOLLAND ? (
              <div className="border-border-base  text-brand-dark relative rounded-md  shadow-trackorderBox flex-1 group address__box">
                <h3 className="font-normal text-xl font-sofia  bg-brand-darkblue py-2 rounded-tl-lg rounded-tr-lg text-white text-center ">
                  {translate('shipment-details')}
                </h3>
                <div className="text-[15px] px-6 p-1">
                  {progressdetail && progressdetail.length > 0 ? (
                    (() => {
                      const latestProgress = progressdetail.at(0) // Get latest entry
                      if (!latestProgress) return null

                      let {
                        activity,
                        deliverylocation,
                        deliverydate,
                        deliverytime,
                      } = latestProgress

                      const isDefaultCondition =
                        activity === ORDER_TRACKING.ORDER_PROCESSED ||
                        activity === ORDER_TRACKING.ORIGIN_SCAN ||
                        activity === ORDER_TRACKING.OUT_FOR_DELIVERY ||
                        activity.includes(ORDER_TRACKING.DELIVERED)

                      activity = isUpsFreight
                        ? activity
                        : activity === ORDER_TRACKING.ORIGIN_SCAN
                        ? ORDER_TRACKING.SHIPPED
                        : !isDefaultCondition
                        ? ORDER_TRACKING.IN_TRANSIT
                        : activity

                      return (
                        <>
                          <div
                            className={`text-base font-semibold my-2 ${
                              activity === ORDER_TRACKING.IN_TRANSIT
                                ? 'text-yellow-100'
                                : 'text-brand-green'
                            }`}
                          >
                            <BsCheckCircleFill className="inline-block me-3" />
                            {activity}
                          </div>
                          {deliverylocation && (
                            <div className="text-sm text-brand-muted">
                              {deliverylocation}
                            </div>
                          )}
                          <div className="text-sm text-brand-dark">
                            {formatDate(deliverydate, deliverytime)}
                          </div>
                          {progressdetail.length > 1 && (
                            <Link
                              href="javacript:void(0)"
                              className={
                                'text-xs font-sofia sm:absolute bottom-3 right-3 text-brand-darkblue underline mt-3'
                              }
                              onClick={handleShipmentDetails}
                            >
                              View Details
                            </Link>
                          )}
                        </>
                      )
                    })()
                  ) : (
                    <div>
                      {translate('click-here')}
                      <Link
                        target="_blank"
                        className="text-brand underline"
                        href={`https://www.ups.com/track?loc=null&tracknum=${tracking}&requester=WT/trackdetails`}
                      >
                        {tracking}
                      </Link>
                      {translate('to-info')}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ''
            )}
            <div
              className="border-border-base  text-brand-dark relative rounded-md  shadow-trackorderBox flex-1 group address__box"
              id="headlessui-radiogroup-option-:r1h:"
            >
              <h3 className="font-normal text-xl font-sofia  bg-brand-darkblue py-2 rounded-tl-lg rounded-tr-lg text-white text-center ">
                {translate('shipping-address', { ns: 'trackorder' })}
              </h3>
              <div
                className="text-[15px] px-6 p-1 "
                id="headlessui-description-:r1j:"
              >
                <div>
                  {shipping_address.firstname} {shipping_address.lastname}
                </div>
                <div> {shipping_address.street}, </div>
                <div>{shipping_address.city?.toUpperCase()}</div>
                <div>
                  {shipping_address.region} - {shipping_address.postcode}
                </div>
                <div>{shipping_address.telephone}</div>
              </div>
            </div>
          </div>
          <div
            className="flex flex-col xl:flex-row gap-4 my-5 lg:items-start"
            id="headlessui-radiogroup-:rb:"
            role="radiogroup"
          >
            <div className="border-border-base font-sofia text-brand-dark shadow-trackorderBox relative rounded-md xl:max-w-xs flex-1 group min-h-32">
              <h3 className="font-normal text-xl  bg-brand-darkblue py-2 rounded-tl-lg rounded-tr-lg text-white text-center ">
                {translate('tracking-id')}
              </h3>

              <div className="pt-5">
                <div className="font-normal mb-5 font-sofia">
                  {Object.values(tracking_info).map(
                    (trackingDetail: any, index: number) => {
                      const { track_data }: any = trackingDetail
                      if (!Object.values(track_data)?.length) return
                      const { tracking } = track_data
                      return (
                        <div
                          key={index}
                          onClick={() => handleSelection(index)}
                          className={` flex justify-between items-center cursor-pointer py-2 ps-5 pe-2  ${
                            selected === index ? 'bg-grey-600' : ''
                          }`}
                        >
                          <Link href="javacript:void(0)">{tracking} </Link>
                          <span>
                            <IoIosArrowForward
                              className="text-brand"
                              fontSize={20}
                            />
                          </span>
                        </div>
                      )
                    },
                  )}
                </div>
              </div>
            </div>
            <div
              className=" text-brand-dark relative  rounded-md shadow-trackorderBox flex-1 group address__box"
              id="headlessui-radiogroup-option-:r1h:"
            >
              <h3 className="ffont-normal text-xl  bg-brand-darkblue py-2 rounded-tl-lg rounded-tr-lg text-white text-center ">
                {translate('text-estimated-delivery')}
              </h3>
              <div className="pb-5 px-4 text-[15px]">
                {message ? (
                  <div>{message}</div>
                ) : carrier === ORDER_TRACKING.YRC ? (
                  <YRC
                    {...Object.values(tracking_info)[selected]?.track_data}
                  />
                ) : carrier === ORDER_TRACKING.HOLLAND ? (
                  <Holland
                    {...Object.values(tracking_info)[selected]?.track_data}
                  />
                ) : (
                  <div className="font-sm text-sm">
                    <div className="font-semibold mt-5 mb-2">
                      {formatDate(deliverydate, deliverytime)}
                    </div>
                    <div>
                      {translate('click-here')}{' '}
                      <Link
                        target="_blank"
                        className="text-brand  underline"
                        href={`https://www.ups.com/track?loc=null&tracknum=${tracking}&requester=WT/trackdetails`}
                      >
                        {tracking}
                      </Link>
                      {translate('to-info')}
                    </div>
                    {weight && (
                      <div className="flex">
                        <span> {translate('weight')}: </span>
                        <span>{weight}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className="flex flex-col xl:flex-row gap-10 my-5 lg:items-start"
            id="headlessui-radiogroup-:rb:"
            role="radiogroup"
          >
            {items?.length && (
              <div
                className="border-border-base  text-brand-dark relative rounded-md  shadow-trackorderBox flex-1 address__box"
                id="headlessui-radiogroup-option-:r1h:"
              >
                <h3 className="font-normal text-xl font-sofia  bg-brand-darkblue py-2 rounded-tl-lg rounded-tr-lg text-white text-center ">
                  {translate('order-item')}
                </h3>

                {items?.map(
                  (
                    {
                      image,
                      name,
                      qty,
                      price,
                    }: {
                      image: string
                      name: string
                      qty: string
                      price: number
                    },
                    i: number,
                  ) => (
                    <div
                      key={i}
                      className=" text-sm flex  items-center text-[15px] px-3 p-1 "
                    >
                      <Image alt={name} width={70} height={70} src={image} />
                      <div className="font-semibold text-brand my-8 ml-3">
                        <span className="underline font-medium">{name}</span>
                        <div className="font-semibold text-brand-dark">
                          {translate('qty-2-price')}: ${price}
                        </div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            )}
          </div>
        </>
      )}
    </>
  )
}

const YRC = ({
  freightBillNumber,
  currentStatusCode,
  currentStatusMessage,
  currentStatusDate,
  pickupDate,
  estimatedDeliveryDate,
  originCity,
  originState,
  originZip,
  destinationCity,
  destinationState,
  destinationZip,
  tenderCode,
}: any) => {
  const { t: translate } = useTranslation('trackorder')

  return (
    <div>
      <div className="row mt-3">
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('yrc-feright-pro')} #</b>
          </p>
          <p className="m-0">{freightBillNumber}</p>
        </div>
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('est-delivery')}</b>
          </p>
          <p className="m-0">{estimatedDeliveryDate}</p>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('current-status')}</b>
          </p>
          <p className="m-0">
            {currentStatusCode === 'DELIVERED'
              ? ORDER_TRACKING.DELIVERED
              : currentStatusMessage?.split(':')[0]}
          </p>
        </div>
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('status-updated')}</b>
          </p>
          <p className="m-0">{currentStatusDate}</p>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('pickup-date')}</b>
          </p>
          <p className="m-0">{pickupDate}</p>
        </div>
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('appointment-date-time')}</b>
          </p>
          <p className="m-0">{tenderCode}</p>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('ship-form')}</b>
          </p>
          <p className="m-0">
            {originCity} {originState} {originZip}
          </p>
        </div>
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('ship-to')}</b>
          </p>
          <p className="m-0">
            {destinationCity} {destinationState} {destinationZip}
          </p>
        </div>
      </div>
    </div>
  )
}

const Holland = ({
  currentstatus,
  pronumber,
  bolnumber,
  ponumber,
  destination,
  consignee,
  origin,
  shipper,
  service_type,
  appointment,
  pickupdate,
  standarddeliverydate,
}: any) => {
  const { t: translate } = useTranslation('trackorder')

  return (
    <div>
      <div className="row mt-3">
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('current-status')}</b>
          </p>
          <p>{currentstatus}</p>
        </div>
        <div className="col-md-10">
          <p className="m-0">
            <b>{translate('standard-delivery')}</b>
          </p>
          <p>{standarddeliverydate}</p>
        </div>
      </div>
    </div>
  )
}
export default OrderTrackingInfo
